<template>
    <form-section
        id="mortgage"
        method="patch"
        :url="url"
        :read_only="read_only"
    >
        <mortgage-cash-purchase
            v-model="is_cash_purchase"
            :read_only="read_only"
        />

        <div v-if="! is_cash_purchase">
            <mortgage-contingency-date
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-application-signed
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-application-sent
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-copy-sent-loan-officer
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-interest-rate
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-interest-rate-locked
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-estimate-received
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-estimate-approved
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <calculations-index
                :property="property"
                :read_only="read_only"
            />

            <mortgage-hoa-fees
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-taxes
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-insurance
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-commitment
                :mortgage="property.mortgage"
                :read_only="read_only"
            />

            <mortgage-clear-to-close
                :mortgage="property.mortgage"
                :read_only="read_only"
            />
        </div>
    </form-section>
</template>

<script>
import FormSection from '../../components/form-section.vue';
import MortgageCashPurchase from './mortgage-cash-purchase.vue';
import MortgageContingencyDate from './mortgage-contingency-date.vue';
import MortgageApplicationSigned from './mortgage-application-signed.vue';
import MortgageApplicationSent from './mortgage-application-sent.vue';
import MortgageCopySentLoanOfficer from './mortgage-copy-sent-loan-officer.vue';
import MortgageInterestRate from './mortgage-interest-rate.vue';
import MortgageInterestRateLocked from './mortgage-interest-rate-locked.vue';
import MortgageEstimateReceived from './mortgage-estimate-received.vue';
import MortgageEstimateApproved from './mortgage-estimate-approved.vue';
import CalculationsIndex from './calculations/calculations-index.vue';
import MortgageTerm from './mortgage-term.vue';
import MortgagePayments from './mortgage-payments.vue';
import MortgageHoaFees from './mortgage-hoa-fees.vue';
import MortgageTaxes from './mortgage-taxes.vue';
import MortgageInsurance from './mortgage-insurance.vue';
import MortgageTotalMonthlyPayments from './mortgage-total-monthly-payments.vue';
import MortgageCommitment from './mortgage-commitment.vue';
import MortgageClearToClose from './mortgage-clear-to-close.vue';

export default {
    components: {
        FormSection,
        MortgageCashPurchase,
        MortgageContingencyDate,
        MortgageApplicationSigned,
        MortgageApplicationSent,
        MortgageCopySentLoanOfficer,
        MortgageInterestRate,
        MortgageInterestRateLocked,
        MortgageEstimateReceived,
        MortgageEstimateApproved,
        CalculationsIndex,
        MortgageTerm,
        MortgagePayments,
        MortgageHoaFees,
        MortgageTaxes,
        MortgageInsurance,
        MortgageTotalMonthlyPayments,
        MortgageCommitment,
        MortgageClearToClose,
    },

    props: {
        property: {},
        url: {},
        read_only: { default: false },
    },

    data() {
        return {
            is_cash_purchase: this.property.mortgage.is_cash_purchase,
        }
    },
}
</script>
